import React, { useState } from "react";
import UserAvatar from "./UserAvatar";
import {parameterize} from "../../../javascripts/utils";
import TooltipTrigger from "../bootstrap/TooltipTrigger";
import {createElementFromHTML} from "../../utils/utilsHelpers";
import Placeholder from "react-bootstrap/Placeholder";

export default function UserCard(props) {

    let {
        user,
        avatarSize=60,
        showAvatarDot=false,
        avatarDotColor='pro',
        orientation='horizontal',
        showBadges=false,
        nameFs='',
        cardClasses='',
        nameClasses='',
        userDetailsClasses='',
        labelBlock=false,
        renderAsLink=true,
        asPlaceholder=false,
        productUser=null,
        forceHeight=true,
        verifiedAvatar=false
    } = props;

    const renderUserName = () => {
        if(asPlaceholder) {
            return (
                <Placeholder animation={'glow'}>
                    <Placeholder xs={4} size={'sm'} bg={'gray-400'} />
                </Placeholder>
            )
        } else if(renderAsLink) {
            return (
                <a
                    className={`author-info block-link ${nameFs && 'font-' + nameFs} ${nameClasses}`}
                    href={user.has_activities ? user.url : ''}
                    data-href={user.has_activities ? '' : user.url}
                    itemProp={'author'}>
                    {user.username}
                </a>
            )
        } else {
            return (
                <div className={`author-info  ${nameFs && 'font-' + nameFs} ${nameClasses}`} itemProp={'author'}>{user.username}</div>
            )
        }
    }

    const renderUserBadges = () => {
        if(showBadges) {
            return  (
                <div className={`labels ${labelBlock && 'label-block'}`}>
                    {renderLabel()}
                    {renderBadge()}
                </div>
            )
        }
    }

    const renderLabel = () => {
        if(user.label) {
            return (
                <TooltipTrigger id={`ltt_${user.id}`} placement={'bottom'} content={user.label_tooltip}>
                    <div className={`badge badge-${parameterize(user.label)}`}>
                        <i className={'fal fa-check'} />
                        {user.label}
                    </div>
                </TooltipTrigger>
            )
        }
    }

    const renderBadge = () => {
        if(user.badge) {
            return (
                <TooltipTrigger id={`btt_${user.id}`} placement={'bottom'} content={user.badge.description}>
                    <div className={`badge bg-soft-info text-info`}>
                        <i className={`fal fa-${user.badge.icon || 'chart-bar'}`} />
                        {user.badge.text}
                    </div>
                </TooltipTrigger>
            )
        }
    }

    const renderUserProfession = () => {
        if(asPlaceholder) {
            return (
                <Placeholder animation={'glow'}>
                    <Placeholder xs={6} size={'xs'} bg={'gray-400'} />
                </Placeholder>
            )
        } else {
            return (
                <>
                    {createElementFromHTML(props.professional_info || user.professional_info)}
                </>
            )
        }
    }

    const renderProductUserVerification = () => {
        if(productUser) {
            if(asPlaceholder) {
                return (
                    <Placeholder animation={'glow'}>
                        <Placeholder xs={6} size={'xs'} bg={'gray-400'} />
                    </Placeholder>
                )
            } else {
                return (
                    <>
                        Verified user of {productUser} <TooltipTrigger id={`pu-tt_${user.id}`} placement={'bottom'} content={user.label_tooltip}>
                            <i className={'fal fa-question-circle font-12 text-blue-link ps-1'} /></TooltipTrigger>
                    </>
                )
            }
        }
    }

    return (
        <div className={`user-card user-card-${orientation} ${labelBlock && 'flex-wrap' } h-auto ${cardClasses}`} style={ forceHeight ? { minHeight: '95px'} : {}}>
           <div className={`user-details user-details-${orientation}`}>
               <div className={'w-auto position-relative'}>
                   <UserAvatar user={user} avatarSize={avatarSize} />
                   {showAvatarDot && <div className={`position-absolute top-0 start-5 bg-${avatarDotColor} rounded-pill`} style={{ width: '13px', height: '13px' }} />}
                   {verifiedAvatar && <div className={'position-absolute top-75 translate-middle-x end-5 branding-p branding-p-primary branding-p-sm text-center'}>
                       <i className={'fas fa-check text-white'} />
                   </div>}
               </div>
               <div className={`details me-2 ${asPlaceholder && 'w-100'}`}>
                   <div className={'name'}>{renderUserName()}</div>
                   <div className={`info ${userDetailsClasses || 'text-medium'}`}>
                       {renderUserProfession()}
                       {renderProductUserVerification()}
                   </div>
               </div>
           </div>
            {renderUserBadges()}
        </div>
    )
}